<template>
    <!-- 进度条组件 -->
    <el-progress 
    :percentage="percentage"
    :status="status"
    :format="format"
    :stroke-width="height"
    :text-inside="inset"
    :color="color"
    :type="type"
    :width="width"
    :show-text="text"
    :stroke-linecap="bothShape"
    />
</template>
<script>
export default {
    name:"VelProgress",
    props:{
        status:String,
        format:Function,
        height:Number,
        isInset:Boolean,
        color:String,
        type:[String,Function,Array],
        width:Number,
        isText:Boolean,
        bothShape:String,
        percentage:{
            type:Number,
            required:true,
        }
    },
    data() {
        return {
            inset:false,
            text:false,
        };
    },
    created() {
        this.initDataFn()
    },
    methods: {
        initDataFn(){
            this.isText ? this.text = true : this.text
            this.isInset ? this.inset = true : this.inset
        }
    }
}
</script>